import { DISABLED_OPACITY as p } from "../../../../styles/colors/consts.js";
import { sizeMap as u } from "../consts.js";
import a from "./useIconButtonColorStyleProps.js";
const d = {
  display: "block",
  borderRadius: "xxlarge"
};
function f({
  tone: i,
  disabled: o,
  blend: t,
  size: r,
  fill: c
}) {
  const l = o ? "not-allowed" : "pointer", s = o ? p : "1", n = a({
    tone: i,
    disabled: o,
    blend: t,
    fill: c
  }), e = r ? u[r].circleSize : void 0;
  return {
    ...d,
    cursor: l,
    opacity: s,
    ...n,
    borderWidth: t ? void 0 : "xxxsmall",
    borderStyle: t ? void 0 : "solid",
    height: e,
    width: e
  };
}
export {
  f as default
};
